import { useAppSelector } from "../../store/hooks/hooks";
import Result from "../../components/common/Result";
import { Trans } from "react-i18next";

const ResultTrend = () => {
	const resultTrend = useAppSelector(state => state.materialBalance.resultTrend);
	const results = [
		{ id: "giip", value: resultTrend.giip },
		{ id: "g", value: resultTrend.g },
		{ id: "rf", value: resultTrend.rf },
		{ id: "r", value: resultTrend.r },
	];

	return (
		<fieldset className="material-balance__result-trend round-corner-container">
			<div className="pvt__intermediate_results">
				{results.map(result => (
					<div className="result-row material-balance__result-trend-row" key={result.id}>
						<div className="material-balance__result-trend-label">
							<Trans
								ns="material_balance"
								i18nKey={`result_labels.${result.id}`}
								components={{
									sub: <sub />,
									sup: <sup />,
								}}
							/>
						</div>
						<Result
							id={`material-balance-result-${result.id}`}
							unit={
								<Trans
									ns="material_balance"
									i18nKey={`result_units.${result.id}`}
									components={{
										sub: <sub />,
										sup: <sup />,
									}}
								/>
							}
							value={result.value?.toString()}
						/>
					</div>
				))}
			</div>
		</fieldset>
	);
};

export default ResultTrend;